import React from 'react';
import { DropzoneInputProps } from 'react-dropzone';

export const DropzoneInputContext = React.createContext<DropzoneInputProps>(null);
